import { useState } from 'react';
import PropTypes from 'prop-types';
import { Stack, Button, Text, Group, Box } from '@mantine/core';
import sidingButton from '../images/ui_buttons/siding_button.png';
import brickStoneButton from '../images/ui_buttons/brickStone_button.png';
import whiteSiding from '../images/ui_buttons/whiteSiding_button.png';
import tanSiding from '../images/ui_buttons/tanSiding_button.png';
import brownSiding from '../images/ui_buttons/brownSiding_button.png';
import blueSiding from '../images/ui_buttons/blueSiding_button.png';
import redBrick from '../images/ui_buttons/redBrick_button.png';
import tanBrick from '../images/ui_buttons/tanBrick_button.png';
import lightStone from '../images/ui_buttons/lightStone_button.png';
import darkStone from '../images/ui_buttons/darkStone_button.png';
import { colors, fontSize } from '../constants';
import { useAppContext, SET_FACADE } from '../context/AppContext';

const HouseMaterialMobile = ({ selectedFacade, onFacadeClick }) => {
	const [sidingOrMasonry, setSidingOrMasonry] = useState(null);

  const { dispatch } = useAppContext();

	const handleFacadeChoice = (facadeId) => {
		console.log('HouseMaterialMobile received click on', facadeId);
    dispatch({ type: SET_FACADE, payload: facadeId });
		onFacadeClick(facadeId);
	};


	// Render functions for better code organization
	const renderInitialButtons = () => (
		<Stack gap="20px" align="center" style={{ width: '100%' }}>
			<Text style={{
				color: colors.white,
				fontSize: fontSize.xl,
				fontWeight: 'bold',
				textAlign: 'center',
        marginTop: '10px',
				marginBottom: '0px'
			}}>
				House Material
			</Text>
			
			<Group justify="center" gap="9vw" style={{ width: '100%' }}>
				<Button
					variant="filled"
					onClick={() => setSidingOrMasonry('siding')}
					styles={{
						root: {
							backgroundColor: 'transparent',
							border: 'none',
							borderRadius: '20px',
							height: 90,
							width: 90,
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							padding: 0
						}
					}}
				>
					<img src={sidingButton} alt='Siding' style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
				</Button>
				
				<Button
					variant="filled"
					onClick={() => setSidingOrMasonry('masonry')}
					styles={{
						root: {
							backgroundColor: 'transparent',
							border: 'none',
							borderRadius: '20px',
							height: 90,
							width: 90,
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							padding: 0
						}
					}}
				>
					<img src={brickStoneButton} alt='Brick/Stone' style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
				</Button>
			</Group>
		</Stack>
	);

	const renderSidingButtons = () => (
		<Stack gap="15px" align="center" style={{ width: '100%' }}>
			<Text style={{
				color: colors.white,
				fontSize: fontSize.xl,
				fontWeight: 'bold',
				textAlign: 'center',
				marginBottom: '0px',
        marginTop: '10px'
			}}>
				Wood Siding
			</Text>
			
			<Group justify="center" gap="8px" style={{ width: '100%' }}>
				<Button
					variant="filled"
					onClick={() => handleFacadeChoice('siding_white')}
					styles={{
						root: {
							backgroundColor: 'transparent',
							border: selectedFacade === 'siding_white' ? '2px solid #475a46' : 'none',
							borderRadius: '8px',
							height: 70,
							width: 70,
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							padding: 0
						}
					}}
				>
					<img src={whiteSiding} alt='White Siding' style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '8px' }} />
				</Button>
				
				<Button
					variant="filled"
					onClick={() => handleFacadeChoice('siding_tan')}
					styles={{
						root: {
							backgroundColor: 'transparent',
							border: selectedFacade === 'siding_tan' ? '2px solid #475a46' : 'none',
							borderRadius: '8px',
							height: 70,
							width: 70,
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							padding: 0
						}
					}}
				>
					<img src={tanSiding} alt='Tan Siding' style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '8px' }} />
				</Button>
				
				<Button
					variant="filled"
					onClick={() => handleFacadeChoice('siding_brown')}
					styles={{
						root: {
							backgroundColor: 'transparent',
							border: selectedFacade === 'siding_brown' ? '2px solid #475a46' : 'none',
							borderRadius: '8px',
							height: 70,
							width: 70,
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							padding: 0
						}
					}}
				>
					<img src={brownSiding} alt='Brown Siding' style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '8px' }} />
				</Button>
				
				<Button
					variant="filled"
					onClick={() => handleFacadeChoice('siding_blue')}
					styles={{
						root: {
							backgroundColor: 'transparent',
							border: selectedFacade === 'siding_blue' ? '2px solid #475a46' : 'none',
							borderRadius: '8px',
							height: 70,
							width: 70,
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							padding: 0
						}
					}}
				>
					<img src={blueSiding} alt='Blue Siding' style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '8px' }} />
				</Button>
			</Group>
			
			{ /*<Button
				variant="light"
				onClick={handleShowInitialButtons}
				styles={{
					root: {
						backgroundColor: colors.darkerGrey,
						color: colors.white,
						border: 'none',
						fontWeight: 'bold',
						minHeight: '40px',
						fontSize: fontSize.md,
						marginTop: '10px'
					}
				}}
			>
				Back
			</Button> */}
		</Stack>
	);

	const renderMasonryButtons = () => (
		<Stack gap="15px" align="center" style={{ width: '100%' }}>
			<Text style={{
				color: colors.white,
				fontSize: fontSize.xl,
				fontWeight: 'bold',
				textAlign: 'center',
				marginBottom: '0px',
        marginTop: '10px'
			}}>
				Brick/Stone
			</Text>
			
			<Group justify="center" gap="8px" style={{ width: '100%' }}>
				<Button
					variant="filled"
					onClick={() => handleFacadeChoice('brick_red')}
					styles={{
						root: {
							backgroundColor: 'transparent',
							border: selectedFacade === 'brick_red' ? '2px solid #475a46' : 'none',
							borderRadius: '8px',
							height: 70,
							width: 70,
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							padding: 0
						}
					}}
				>
					<img src={redBrick} alt='Red Brick' style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '8px' }} />
				</Button>
				
				<Button
					variant="filled"
					onClick={() => handleFacadeChoice('brick_tan')}
					styles={{
						root: {
							backgroundColor: 'transparent',
							border: selectedFacade === 'brick_tan' ? '2px solid #475a46' : 'none',
							borderRadius: '8px',
							height: 70,
							width: 70,
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							padding: 0
						}
					}}
				>
					<img src={tanBrick} alt='Tan Brick' style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '8px' }} />
				</Button>
				
				<Button
					variant="filled"
					onClick={() => handleFacadeChoice('stone_light')}
					styles={{
						root: {
							backgroundColor: 'transparent',
							border: selectedFacade === 'stone_light' ? '2px solid #475a46' : 'none',
							borderRadius: '8px',
							height: 70,
							width: 70,
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							padding: 0
						}
					}}
				>
					<img src={lightStone} alt='Light Stone' style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '8px' }} />
				</Button>
				
				<Button
					variant="filled"
					onClick={() => handleFacadeChoice('stone_dark')}
					styles={{
						root: {
							backgroundColor: 'transparent',
							border: selectedFacade === 'stone_dark' ? '2px solid #475a46' : 'none',
							borderRadius: '8px',
							height: 70,
							width: 70,
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							padding: 0
						}
					}}
				>
					<img src={darkStone} alt='Dark Stone' style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '8px' }} />
				</Button>
			</Group>
			
			{ /* <Button
				variant="light"
				onClick={handleShowInitialButtons}
				styles={{
					root: {
						backgroundColor: colors.darkerGrey,
						color: colors.white,
						border: 'none',
						fontWeight: 'bold',
						minHeight: '40px',
						fontSize: fontSize.md,
						marginTop: '10px'
					}
				}}
			>
				Back
			</Button> */}
		</Stack>
	);

	return (
		<Box style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
			{sidingOrMasonry === null && renderInitialButtons()}
			{sidingOrMasonry === 'siding' && renderSidingButtons()}
			{sidingOrMasonry === 'masonry' && renderMasonryButtons()}
		</Box>
	);
};

HouseMaterialMobile.propTypes = {
	selectedFacade: PropTypes.string,
	onFacadeClick: PropTypes.func.isRequired
};

export default HouseMaterialMobile;
